module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('information-popup', {
    attrs: {
      "modal-id": "inscriptionExamplesPopup"
    }
  }, [_c('template', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Inscription Examples")]), _vm._v(" "), _vm._t("default", [_c('div', {
    staticClass: "modal-body inscription-modal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('h3', {
    staticClass: "text-danger"
  }, [_vm._v("INSPIRING")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("4x8")])]), _vm._v(" "), _c('p', [_vm._v("A SOLID FUTURE")]), _vm._v(" "), _c('p', [_vm._v("FOR THE KIDS")]), _vm._v(" "), _c('p', [_vm._v("OF CALDWELL! KS")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('h3', {
    staticClass: "text-danger"
  }, [_vm._v("FAMILY")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("4x8")])]), _vm._v(" "), _c('p', [_vm._v("OUR ROOTS ARE")]), _vm._v(" "), _c('p', [_vm._v("HERE IN CALDWELL")]), _vm._v(" "), _c('p', [_vm._v("THE JONES FAM")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('h3', {
    staticClass: "text-danger"
  }, [_vm._v("TEAM")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("4x8")])]), _vm._v(" "), _c('p', [_vm._v("#YOTE FAM")]), _vm._v(" "), _c('p', [_vm._v("STOMPING GROUND")]), _vm._v(" "), _c('p', [_vm._v("GO PURPLE & GOLD")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('h3', {
    staticClass: "text-danger"
  }, [_vm._v("REMEMBRANCE")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("4x8")])]), _vm._v(" "), _c('p', [_vm._v("IN HONOR OF")]), _vm._v(" "), _c('p', [_vm._v("BRIAN ARMSTRONG")]), _vm._v(" "), _c('p', [_vm._v("1965-2009")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('h3', {
    staticClass: "text-danger"
  }, [_vm._v("ANNIVERSARY")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("4x8")])]), _vm._v(" "), _c('p', [_vm._v("OUR LOVE GREW")]), _vm._v(" "), _c('p', [_vm._v("IN CALDWELL 1965")]), _vm._v(" "), _c('p', [_vm._v("JIM & MARY ROSS")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('h3', {
    staticClass: "text-danger"
  }, [_vm._v("FATHER'S DAY")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("4x8")])]), _vm._v(" "), _c('p', [_vm._v("DANNY NEWMAN")]), _vm._v(" "), _c('p', [_vm._v("NUMBER ONE DAD!")]), _vm._v(" "), _c('p', [_vm._v("LOVE, YOUR SON")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('h3', {
    staticClass: "text-danger"
  }, [_vm._v("MOTHER'S DAY")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("4x8")])]), _vm._v(" "), _c('p', [_vm._v("HAPPY MOTHER'S")]), _vm._v(" "), _c('p', [_vm._v("DAY MOM!")]), _vm._v(" "), _c('p', [_vm._v("JEN & DON BRADY")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('h3', {
    staticClass: "text-danger"
  }, [_vm._v("GENERAL")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("4x8")])]), _vm._v(" "), _c('p', [_vm._v("CALDWELL, IDAHO")]), _vm._v(" "), _c('p', [_vm._v("MY HOME & HEART")]), _vm._v(" "), _c('p', [_vm._v("VAL HULL")])])])])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bf16c996","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/InscriptionExamples.vue
// module id = mJEz
// module chunks = 1